import { Box, Stack, theme } from '@dtx-company/design-system/src'
import { PrivacyTOSFooter } from './components/PrivacyTOSFooter'
import { ProfileImageHeader } from './components/ProfileImageHeader'
import { SettingsList } from './components/SettingsList'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { StorageVisualizerComponent } from '../NavigationMenuV3/components'
import { UpgradeButton } from '../MobileMoreOptionsSheet/components/UpgradeButton'
import { useProfileMenuState } from './hooks/useProfileMenuState'
import React from 'react'

export const ProfileMenu: React.FC<{ isDesktop?: boolean }> = ({ isDesktop }) => {
  const {
    orgName,
    fullName,
    profilePicture,
    email,
    planLabel,
    closeAllMenus,
    showReferAFriendOption,
    progressBarConfig,
    onClickEditProfilePicture,
    showUpgradeButton,
    onClickUpgradeButton
  } = useProfileMenuState({ isDesktop })

  return (
    <Stack
      direction="column"
      sx={{ flexDirection: 'column', width: '100%', overflowY: 'auto' }}
      data-testid="profile-menu"
    >
      <ProfileImageHeader
        orgName={orgName}
        fullName={fullName}
        profilePicture={profilePicture}
        email={email}
        planLabel={planLabel}
        onClickEditProfilePicture={onClickEditProfilePicture}
        isDesktop={isDesktop}
      />
      <Box sx={{ maxHeight: 'calc(100vh - 244px)' }}>
        <Box sx={theme => ({ paddingX: theme.spacing(4), paddingBottom: theme.spacing(4) })}>
          <StorageVisualizerComponent {...progressBarConfig} />
        </Box>
        {showUpgradeButton && (
          <UpgradeButton
            onClick={() => {
              closeAllMenus()
              onClickUpgradeButton()
            }}
            {...{ paddingX: theme.spacing(4), marginBottom: theme.spacing(6) }}
          />
        )}
        <SettingsList
          closeAllMenus={closeAllMenus}
          showReferAFriendOption={showReferAFriendOption}
          isDesktop={isDesktop}
        />
        <PrivacyTOSFooter />
        <Spacer mb="20px" />
      </Box>
    </Stack>
  )
}
